import {
    DataGrid, GridFooter, GridFooterContainer
} from '@mui/x-data-grid';

import {deleteDataPointXref, getXrefs} from "./DataPointXrefClient";

import {useState, useEffect} from "react";
import DataPointXrefDrawerForm from "./DataPointXrefDrawer";

import * as React from "react";
import Box from "@mui/material/Box";

import Typography from "@mui/material/Typography";

import {changeDataPointXref} from "./dataPointXrefSlice";
import {useDispatch, useSelector} from "react-redux";
import {changeCrudSnackbar} from "../CommonComponents/crudSnackbarSlice";
import CrudSnackbar from "../CommonComponents/CrudSnackbar";
import AddFiltersExportToolbar from "../CommonComponents/AddFiltersExportToolbar";
import {DataPointXrefGridColumns} from "./DataPointXrefGridColumns";
import DpxInfoDialogue from "./Info/DpxInfoDialogue";
import {Tooltip} from "@mui/material";





function DataPointXrefGrid() {
    const [dataPointXrefs, setDataPointXrefs] = useState([]);
    const [collapsed, setCollapsed] = useState(false);
    const [fetching, setFetching] = useState(true);
    const [showDrawer, setShowDrawer] = useState(false);
    const [deleteOpen, setDeleteOpen] = React.useState(false);
    const selectorXrefId = useSelector((state) => state.dataPointXrefSlc.value.id);
    const selectorXrefDrawerState = useSelector((state) => state.dataPointXrefSlc.value.xrefDrawerState);
        // const hideActions = useSelector((state) => state.userProfileSlc.value.rights) !== "Super User";
    const hideActions = localStorage.getItem('hideActions') === "true";
    const [dpxInfoOpen, setDpxInfoOpen] = useState(false);
    const selectorXrefGridRefresh = useSelector(state => state.dataPointXrefSlc.value.xrefGridRefresh);


    const dispatchData = useDispatch();




    const fetchDataPointXrefs = React.useCallback(() => {
        return getXrefs()

            .then(data => {
                console.log(data);
                setDataPointXrefs(data);
            });
    }, []);


    useEffect(() => {
        console.log("This is working so far...");
        fetchDataPointXrefs();
    }, [fetchDataPointXrefs]);

    useEffect(() => {
        if (!selectorXrefGridRefresh) return;

        console.log("xref fetch triggered by grid refresh = true");

        fetchDataPointXrefs().finally(() => {
            dispatchData(changeDataPointXref({
                xrefGridRefresh: false
            }));
        });
    }, [selectorXrefGridRefresh, fetchDataPointXrefs, dispatchData]);

    //
    // const fetchDataPointXrefs = () =>
    //     getXrefs()

    //         .then(data => {
    //             console.log(data);
    //             setDataPointXrefs(data);
    //         })
    // useEffect(() => {
    //     console.log("This is working so far...");
    //     fetchDataPointXrefs();
    // }, []);
    // const renderDataPointXrefs = dataPointXrefs => {
    //     if (dataPointXrefs.length <= 0) {
    //         return "No Data";
    //     }}

    //
    // useEffect(() => {
    //     console.log("xref fetch triggered by grid refresh = true");
    //     fetchDataPointXrefs();
    //     dispatchData(changeDataPointXref({xrefGridRefresh: false}));
    // }, [useSelector((state) => state.dataPointXrefSlc.value.xrefGridRefresh)===true]);


    const removeDataPointXref = () => {
        deleteDataPointXref(selectorXrefId).then(() => {
            // successNotification("DataPointXref deleted",`DataPointXref with id ${selectorXrefId} was deleted`);
            dispatchData(changeDataPointXref({xrefGridRefresh: true}));
            dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record deleted"}));
        });
    }


    const handleAdd = () => {
        dispatchData(changeDataPointXref({
            id: null, dataPointId: null, attributeId: null, ordinalNumber: null,
            xrefStatus: null,
            dataPointCode: null, dataPointName: null, dataType: null, dataPointStatus: null,
            attributeCode:null, attributeName: null, category: null, attributeStatus: null,
            createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
            xrefDrawerState: true, xrefDrawerMode: "Add"}));
    };



    function CustomFooter() {
        return (

            <GridFooterContainer>
                <Box flexGrow={9}>
                </Box>

                <Box sx={{ flexGrow: 1 }}>
                    <Typography
                        variant="h7"
                        noWrap
                        component="div"
                        position={"center"}
                        sx={{ display: { xs: "none", sm: "block" } }}
                    >
                        Patent Pending
                    </Typography>
                </Box>
                <Box flexGrow={6}>
                    <GridFooter/>

                </Box>
            </GridFooterContainer>
        );
    }

    const handleClickedRow = (xrefData) => {

        console.log('Xref data from clicked row');
        console.log(xrefData);
        dispatchData(changeDataPointXref({
            id: xrefData.id, dataPointId: xrefData.dataPointId, attributeId: xrefData.attributeId,
            ordinalNumber: xrefData.ordinalNumber, xrefStatus: xrefData.xrefStatus,
            dataPointCode: xrefData.dataPointCode, dataPointName: xrefData.dataPointName, dataType: xrefData.dataType, dataPointStatus: xrefData.dataPointStatus,
            attributeCode: xrefData.attributeCode, attributeName: xrefData.attributeName, category: xrefData.category, attributeStatus: xrefData.attributeStatus,
            createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null}))
    };


    const handleDpxInfo = () => {
        setDpxInfoOpen(true);
    };

    const handleCloseDpxInfo = () => {
        setDpxInfoOpen(false);
    };



    return (
        <div style={{ height:800 , width: '100%' }}>
            <Box sx={{height: 70, pt: 1, pl: 3}}>
                <Tooltip enterDelay={1000} enterNextDelay={1000} title={"Click for information."}>
                <h3
                    style={{cursor:'pointer'}}   onClick={() => handleDpxInfo()}
                >Data Pont Xrefs</h3>
                </Tooltip>
            </Box>
            <DpxInfoDialogue
                open={dpxInfoOpen}
                onClose={handleCloseDpxInfo}
            />
            {selectorXrefDrawerState &&
            <DataPointXrefDrawerForm
                showDrawer={showDrawer}
                setShowDrawer={setShowDrawer}
                fetchDataPointXrefs={fetchDataPointXrefs}
            />}
            <DataGrid
                aria-label={"DataPointXrefs"}
                rows={dataPointXrefs}
                disableDensitySelector={true}
                disableColumnSelector={true}
                onRowClick = {(dataPointXrefs)=>handleClickedRow(dataPointXrefs.row)}
                // columns={columns(fetchDataPointXrefs)}
                columns={DataPointXrefGridColumns({
                    hideActions,
                    onEdit: () => dispatchData(changeDataPointXref({ xrefDrawerState: true, xrefDrawerMode: "Edit" })),
                    onClone: () => dispatchData(changeDataPointXref({ xrefDrawerState: true, xrefDrawerMode: "Clone" })),
                    onDelete: removeDataPointXref
                })}
                density={"compact"}
                pageSize={20}
                rowsPerPageOptions={[20]}
                components={{
                    Toolbar: AddFiltersExportToolbar,
                    Footer: CustomFooter,
                }}
                componentsProps={{
                    toolbar: {
                        handleAdd: handleAdd
                    }
                }}
            />
            <CrudSnackbar/>
        </div>
    );



}
export default DataPointXrefGrid;



